import { motion } from "motion/react";
import univir from "../../../assets/univir.png";
import build from "../../../assets/build.png";
import second from "../../../assets/second.png";
import t60 from "../../../assets/360.png";
import fourth from "../../../assets/fourth.png";
import faculty from "../../../assets/faculty.png";
import latest from "../../../assets/latest.png";

export default function SetsUsApart() {
  return (
    <div className="w-full flex flex-col items-center justify-center mx-auto overflow-x-hidden">
      {/* Title */}
      <div className="w-full h-auto">
        <div>
          <div
            className="text-[#F6A122] text-3xl text-center md:text-6xl justify-center flex font-bold mt-6"
            style={{ fontFamily: "Montserrat" }}
          >
            What Sets Us Apart
          </div>
        </div>
      </div>

      {/* Changed flex-col only on md screens */}
      <div className="flex flex-col lg:flex-row justify-center items-center w-full">
        {/* Left Side - Cards */}
        <div className="flex justify-center items-center lg:justify-end lg:pr-10 w-full lg:w-[60%] mt-10 mb-10">
          <div className="relative grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-x-12 md:gap-y-16 w-full max-w-[350px] md:max-w-[650px]">
            {/* Cards */}
            <motion.div
              whileHover={{ scale: 1.1 }}
              className="bg-peterriver w-full h-[200px] flex flex-col items-center p-4 md:p-2 md:pt-3 shadow-lg rounded-xl"
              style={{ fontFamily: "Montserrat" }}
            >
              <div
                className="text-lg text-center flex items-center flex-col md:text-xl font-semibold"
                style={{ fontFamily: "Poppins" }}
              >
                <img src={build} className="w-[55px]" /> Company Mapping
              </div>
              <p
                className="text-gray-600 mt-1 text-[13px] text-center"
                style={{ fontFamily: "Poppins" }}
              >
                Better alignment of training with recruiter's requirements
              </p>
            </motion.div>

            <motion.div
              whileHover={{ scale: 1.1 }}
              className="bg-[#EAF7FFF0] w-full h-[200px] flex flex-col items-center p-4 md:p-2 md:pt-3 shadow-lg rounded-xl"
            >
              <div
                className="text-lg text-center flex items-center flex-col md:text-xl font-semibold"
                style={{ fontFamily: "Poppins" }}
              >
                <img src={second} className="w-[55px]" />
                Focused Outcome
              </div>
              <p
                className="text-gray-600 mt-1 text-[13px] text-center"
                style={{ fontFamily: "Poppins" }}
              >
                Specific preparation for jobs, exams, startups, or higher
                studies
              </p>
            </motion.div>

            {/* Center Card (Desktop) */}
            <motion.div className="absolute hidden md:flex w-[260px] h-[180px] p-4 md:p-2 md:pt-3 bg-[#FFF6E8] shadow-lg rounded-xl border border-gray-200 z-10 top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 flex-col justify-center items-center text-center">
              <div
                className="text-lg text-center flex items-center flex-col md:text-xl font-semibold"
                style={{ fontFamily: "Poppins" }}
              >
                <img src={t60} className="w-[55px]" />
                360° Development
              </div>
              <p
                className="text-gray-600 mt-1 text-[13px] text-center"
                style={{ fontFamily: "Poppins" }}
              >
                Covers technical, communication, personality dimensions
              </p>
            </motion.div>

            <motion.div
              whileHover={{ scale: 1.1 }}
              className="bg-[#DDEFFE] w-full h-[200px] flex flex-col items-center p-4 md:p-2 md:pt-3 shadow-lg rounded-xl"
            >
              <div
                className="text-lg text-center flex items-center flex-col md:text-xl font-semibold"
                style={{ fontFamily: "Poppins" }}
              >
                <img src={faculty} className="w-[55px]" />
                Faculty Enablement
              </div>
              <p
                className="text-gray-600 mt-1 text-[13px] text-center"
                style={{ fontFamily: "Poppins" }}
              >
                Faculty receive specialized training to effectively implement this model
              </p>
            </motion.div>

            <motion.div
              whileHover={{ scale: 1.1 }}
              className="bg-[#E1F7FA] w-full h-[200px] flex flex-col items-center p-4 md:p-2 md:pt-3 shadow-lg rounded-xl"
            >
              <div
                className="text-lg text-center flex items-center flex-col md:text-xl font-semibold"
                style={{ fontFamily: "Poppins" }}
              >
                <img src={fourth} className="w-[55px]" />
                Club-based Ecosystem
              </div>
              <p
                className="text-gray-600 mt-1 text-[13px] text-center"
                style={{ fontFamily: "Poppins" }}
              >
                Peer-driven collaborative growth with guided faculty mentors
              </p>
            </motion.div>

            {/* Mobile Version of Exclusive Card */}
            <motion.div
              whileHover={{ scale: 1.1 }}
              className="bg-[#FFF6E8] w-full h-[200px] flex md:hidden flex-col justify-center items-center p-4 shadow-lg rounded-xl border border-gray-200 text-center"
            >
              <div className="text-lg flex items-center flex-col text-center md:text-xl font-semibold">
                <img src={t60} className="w-[55px]" />
                360° Development
              </div>
              <p
                className="text-gray-600 mt-1 text-sm md:text-sm"
                style={{ fontFamily: "Poppins" }}
              >
                Covers technical, communication, personality dimensions
              </p>
            </motion.div>
          </div>
        </div>

        {/* Right Side - Character Image */}
        <div className="w-full lg:w-[40%] flex justify-center items-center h-auto lg:mb-0">
          <img
            src={latest}
            alt="Character"
            className="w-[200px] md:w-[450px] md:h-[600px] object-contain"
          /> 
        </div>
      </div>
    </div>
  );
}